


import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

export default class Xemthem extends React.Component{
  constructor(props){
            super(props);
            this.state = {
                showFilter:"",
                displaytr:"",
                onSet:false,


            }
        } 

    filter=()=>{
        this.setState({showFilter:"showFilter"})
    }

    offCart=()=>{
    	this.setState({showFilter:""})
        
    }
    hanlFilter = () =>{
    	this.props.hanlFilter()
    }
    hanlSearch=(e)=>{
    	console.log(e.target.value)
    	this.props.hanlFilter(e.target.value)
    }
    thoitrang=()=>{
    	this.setState({onSet: !this.state.onSet})
    }
    render(){
    	const {showFilter,onSet, displaytr} = this.state;
		return (
			<div>
				<div className="filter" onClick={this.filter}>
	                <i style={{fontSize:"18px", padding:"8px 11px"}} class="fas fa-filter"></i>
	                <p style={{padding:"0 4px"}}>Filter</p>
	            </div>
				<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
		            <div className={`nav_cart navbar-fixed-top ${showFilter}`} style={{overflowY: "auto"}}>
		                <div className="cart_comple">
		                    <div className="close_qty">
		                        <CloseIcon onClick={this.offCart}/>
		                    </div>
		                    <h3>Filter</h3>
		                    <div className="filter_thoitrang" onClick={this.thoitrang}>THỜI TRANG <i style={{transform: onSet === true ? "rotate(0deg)" : "rotate(180deg)"}} class="fas fa-angle-down"></i></div>
		                    <div class={`${onSet === true ? "displaytr" : ""}form-check_waper`}>
								<form style={{margin:"0"}}>
							        <div>
							            <input id="radio-1" value="tui" onChange={this.hanlSearch} onClick={this.offCart} class="radio-custom" name="radio-group" type="radio" />
							            <label for="radio-1" class="radio-custom-label">Tui</label>
							        </div>
							        <div>
							            <input id="radio-2" value="mong" onChange={this.hanlSearch} onClick={this.offCart} class="radio-custom"name="radio-group" type="radio" />
							            <label for="radio-2" class="radio-custom-label">Mong</label>
							        </div>
							        <div>
							            <input id="radio-3" value="ao" onChange={this.hanlSearch} onClick={this.offCart} class="radio-custom" name="radio-group" type="radio" />
							            <label for="radio-3" class="radio-custom-label">Ao</label>
							        </div>
							    </form>
							</div>
								
		                </div>
		            </div>
		        </div>
	        </div>
		)
	}
}